import React, { useContext } from 'react'
import { navigate } from 'gatsby'

import Button from '../../atoms/button/button'

import tituloHome from '../../../assets/images/tituloHome.png'
import jackpotHome from '../../../assets/images/jackpotHome.png'
import premio1_DO from '../../../assets/images/premio1_DO.png'
import premio2_CO from '../../../assets/images/premio2_CO.png'
import mujeres from '../../../assets/images/mujeres.png'

import { Context } from '../../../context/app-context'

import './bannerSection.scss'

const BannerSection = props => {
  const { mobile } = props

  const { dispatch } = useContext(Context)

  return (
    <div className='f-triviaMujeres-container'>
      <div className='f-triviaMujeres-container__colum1'>
        <div className='f-triviaMujeres-container__colum1__content1'>
          <h2>Ellas</h2>
          <h3>HAN CAMBIADO LA HISTORIA</h3>
          <p>
            ¡Recordemos a estas mujeres que <br /> nos inspiran!
          </p>
        </div>
        {mobile && (
          <img
            className='f-triviaMujeres-container__colum1__imgMujeresMobile'
            src={mujeres}
            alt='mujeres famosas'
          />
        )}
      </div>
      <div className='f-triviaMujeres-container__colum2'>
        <img
          className='f-triviaMujeres-container__colum2__imgTituloHome'
          src={tituloHome}
          alt='titulo de la actividad'
        />
        <div className='f-triviaMujeres-container__colum2__test'>
          <img
            className='f-triviaMujeres-container__colum2__test__imgJackPotHome'
            src={jackpotHome}
            alt='maquina de jackpot'
          />
          <Button
            text='¡Juguemos!'
            size='home'
            onClick={() => {
              navigate('/juega')
            }}
          />
        </div>
      </div>
      <div className='f-triviaMujeres-container__colum3'>
        <div className='f-triviaMujeres-container__colum3__content'>
          <h2>
            Responde las preguntas, <br />
            <span>APRENDE Y GANA</span>{' '}
          </h2>
          <div className='f-triviaMujeres-container__colum3__content__premios'>
            <div className='f-triviaMujeres-container__colum3__content__premios__up'>
              <img
                className='f-triviaMujeres-container__colum3__content__premios__up__imgPremio1'
                src={premio1_DO}
                alt='premio 1'
              />
              <h2 className='f-triviaMujeres-container__colum3__content__premios__up__textUp'>
                Del Top 1 al 10 <br /> <br />
                <span>
                  GANARÁN UN KIT DE PRODUCTOS NOSOTRAS <br/>
                  + UNA BOLSA DE AGUA + UNA MOCHILA

                </span>{' '}
              </h2>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default BannerSection
